import React, { useEffect, useState, useRef } from 'react';
import { useSelector } from 'react-redux';
import Grid from '@material-ui/core/Grid';
import { Card, makeStyles, CardContent, Typography } from '@material-ui/core';
import axios from 'axios';
import SearchBox from '../../../../components/table/SearchBox';
import DataTable from './table';
import { CommonConfig } from '../../../../config/common-config';

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
        marginTop: theme.spacing(6),
    },
    button: {
        fontSize: '15px !important',
        fontWeight: '400 !important',
        borderRadius: '6px',
        textTransform: 'capitalize',
        padding: '6px 25px',
        letterSpacing: 'normal',
    },
    noRecord: {
        display: 'flex',
        justifyContent: 'center',
        background: '#f6f6f6',
        margin: '16px',
        '& h1': {
            alignSelf: 'center',
            color: 'grey',
            fontFamily: 'Rubik',
            fontSize: '14px',
            fontWeight: '400',
        },
    },
    width60: {
        maxWidth: '60% !important',
        flexBasis: '60% !important',
    },
    width40: {
        maxWidth: '40% !important',
    },
}));

function NoofPendingInvoices(props) {
    const classes = useStyles();
    const [rows, setTotalInvoices] = useState([]);
    const [searchQuery, setSearchQuery] = useState('');
    const tennantDetails = useSelector((state) => state.loginsuccessreducer.tennantName);
    const userDetails = useSelector((state) => state.loginsuccessreducer.loggedInUserDetails);
    const usertype = userDetails.result && userDetails.result.data.userType;
    const dbname = tennantDetails.tennantName;
    const [page, setPage] = useState(0);
    const [pageDetails, setPageDetails] = useState('');
    const [loading, setLoading] = useState(false);
    const [previousButton, setpreviousButton] = useState(false);
    const [nextButton, setnextButton] = useState(false);
    const tempToken = useSelector((state) => state.loginsuccessreducer.loggedInUserDetails.result);
    const userToken = tempToken && tempToken.data.token;
    const bearerToken = `Bearer ${userToken}`;

    const [searchData, setSearchData] = useState([]);
    const [noRecordCount, setNoRecordCount] = useState(false);
    const axiosConfig = {
        headers: {
            Authorization: bearerToken,
        },
    };

    const headCells = [
        { id: 'imcName', label: 'Name of the IMC' },
        { id: 'domainName', label: 'Domain Name' },
        { id: 'adminName', label: 'Admin Name' },
        { id: 'adminNumber', label: 'Admin Mobile No.' },
        { id: 'pendingInvoicesCount', label: 'No. of Pending Invoices' },
    ];

    const handleCount = (val) => {
        if (val === 'prev') {
            if (pageDetails.first !== true) {
                setPage((page) => page - 1);
            }
        }
        if (val === 'next') {
            if (pageDetails.last !== true) {
                setPage((page) => page + 1);
            }
        }
    };

    useEffect(() => {
        // console.log("bearerToken", bearerToken)
        getGenInvoices();
    }, [userToken, page, dbname]);

    const getGenInvoices = () => {
        axios
            .get(`${CommonConfig.dev.baseUrl}/api/auth/getIMCOpenCount?page=${page}&size=10&sort=domainName,asc`, {
                headers: {
                    Authorization: bearerToken,
                },
            })
            .then((response) => {
                console.log('response', response.data);
                setTotalInvoices(response.data.content);
                setPageDetails(response.data);
                setLoading(false);
                if (response.data.first) {
                    console.log('first');
                    setpreviousButton(true);
                    setnextButton(false);
                } else if (response.data.last) {
                    console.log('last');
                    setpreviousButton(false);
                    setnextButton(true);
                } else {
                    setpreviousButton(false);
                    setnextButton(false);
                }
            })
            .catch((error) => {
                //console.log(error);
            })
    }

    const getSearchValueAdmin = (data) => {
        axios
            .get(`${CommonConfig.dev.baseUrl}/api/auth/getIMCOpenCount?search=${data}&page=${page}&size=10`, axiosConfig)
            .then((res) => {
                if (res.data) {
                    // console.log('responseresponse11', res.data.content.length);
                    if (res.data.content.length === 0) {
                        // console.log('responseresponse', res.data.content.length);
                        setTotalInvoices([]);
                    }
                    // formatDate(res.data.content);
                    setSearchData(res.data.content);
                    setPageDetails(res.data);
                    setLoading(false);
                    if (res.data.first) {
                        setpreviousButton(true);
                        setnextButton(false);
                    } else if (res.data.last) {
                        setpreviousButton(false);
                        setnextButton(true);
                    } else {
                        setpreviousButton(false);
                        setnextButton(false);
                    }
                }
            })
            .catch((error) => {
            });
    }

    const clearField = () => {
        setSearchQuery('');
        setSearchData([]);
        setPage(0);
        getGenInvoices();
        // getCandidatesBYUser();
        // console.log('clearclear')
    }

    const handleSearchQuery = (data) => {
        // setSearchQuery(searchData);
        setSearchQuery(data);
        // console.log('data', data);
        if (data && data.length > 2) {
            setNoRecordCount(false);
            getSearchValueAdmin(data);
            return true;
        } else {
            setNoRecordCount(true);
        }
        if (!data) {
            setSearchData([]);
            setPage(0);
            getGenInvoices();
        }
    };

    // const handleSearchQuery = (data) => {
    //     setSearchQuery(data);
    // };

    const handleSave = () => { };

    const filteredRow = searchData && searchData.length ? searchData : rows;

    // const filteredRow = searchQuery
    //     ? rows.filter((row) => {
    //         const query = searchQuery.toLowerCase().trim();
    //         return headCells
    //             .map((col) => col.id)
    //             .some((key) => {
    //                 return row[key].toString().toLowerCase().includes(query);
    //             });
    //     })
    //     : rows;



    return (
        <>
            <Card className="custom-table">
                {filteredRow.length > 0 ? (
                    <>
                        <div>
                            <CardContent className="card-title-display">
                                <Grid item xs={12} sm={8}>
                                    <Typography className="card-title">IMC wise Pending Invoices</Typography>
                                </Grid>
                                <Grid item xs={12} sm={6} className="card-search">
                                    <div className="search-field">
                                        <SearchBox searchQuery={searchQuery} onChange={handleSearchQuery} clearField={clearField} placeholder="Search..." />
                                    </div>
                                </Grid>
                            </CardContent>
                        </div>
                        <CardContent className="card-table-display">
                            <DataTable
                                rows={filteredRow}
                                headCells={headCells}
                                saveRow={handleSave}
                                action
                                handleCount={handleCount}
                                pageDetails={pageDetails}
                                loading={loading}
                                prvnxtbt={{ prvBt: previousButton, nxtBt: nextButton }}
                            />
                        </CardContent>
                    </>
                ) : (
                        <div>
                            <CardContent className="card-title-display">
                                <Grid item xs={12} sm={8}>
                                    <Typography className="card-title">IMC wise Pending Invoices</Typography>
                                </Grid>
                                <Grid item xs={12} sm={6} className="card-search">
                                    <div className="search-field">
                                        <SearchBox searchQuery={searchQuery} onChange={handleSearchQuery} placeholder="Search..." />
                                    </div>
                                </Grid>
                            </CardContent>
                            <CardContent className="card-table-display">
                                <div className={classes.noRecord}>
                                    <h1>No records to display</h1>
                                </div>
                            </CardContent>
                        </div>
                    )}
            </Card>
        </>
    );
}

export default NoofPendingInvoices;
